export const locale = {
    lang: 'ar',
    data: {
        INFORMATIONS:'إشعار',
        CONFIRMATION_MESSAGE_PUBLIC_TO_PRIVATE: 'جلستك الآن خاصة. يمكنك إضافة البريد الإلكتروني للمشاركين لمنحهم حق الوصول.',
        CONFIRMATION_MESSAGE_PRIVATE_TO_PUBLIC: 'جلستك الآن عامة. يمكنك مشاركة الرابط مع المشاركين.',
        BUTTON_MESSAGE: 'التأكيد'
        }
   };
